export const SEGMENT_RAW = 'raw';
export const SEGMENT_URL = 'url';
export const SEGMENT_YOUTUBE_VIDEO = 'youtube';
export const SEGMENT_EXTERNAL_IMAGE = 'external-image';
export const SEGMENT_TAG = 'tag';
export const SEGMENT_INTERNAL_LINK = 'internal-link';
export const SEGMENT_EMOJI = 'emoji';
export const SEGMENT_LINE_BREAK = 'line-break';
